import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { SvgIcon } from './SvgIcon'
import * as featherIcons from './feather-icons'

import './Icon.scss'

export { SvgIcon, featherIcons }

// Svg declaration
export const IconStyleSheet = () => (
  <svg display="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      {R.pipe(
        R.toPairs,
        R.map(([key, value]) => (
          <SvgIcon key={key} id={`icon-${key}`} icon={value} />
        )),
      )(featherIcons)}
    </defs>
  </svg>
)

type IconProps = Omit<
  React.SVGProps<SVGUseElement>,
  'className' | 'name' | 'onClick'
> & {
  className?: string
  name?: string
  onClick?: React.MouseEventHandler<SVGSVGElement>
  large?: boolean
}

const Icon = ({
  className,
  name,
  onClick,
  large = false,
  ...props
}: IconProps) => {
  // ? can we check it some how differently to ensure, that everything is good?
  if (!(name && name in featherIcons)) {
    console.warn(`icon "${name}" not found`)
    name = 'missing'
  }
  return (
    <svg
      onClick={onClick}
      className={cx('Icon', { large }, className)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <use {...props} xlinkHref={`#icon-${name}`} />
    </svg>
  )
}
export default Icon
